import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import UploadCampaign from '../../../Components/UploadCampaign';
import VersionDetails from '../../../Components/VersionDetails';
import { createSelector } from 'reselect';
import { toggleAddVersionModal } from '../../../../../../slices/modals/reducer';
import DropFileTable from '../../../Components/DropFileTable';
import { resetVersionDetails, setCampaignLoader, setVersionDetails } from '../../../../../../slices/campaigns/reducer';
import { createVersion } from '../../../../../../slices/campaigns/thunk';

function AddNewVersion({dropFileType = {}}) {
  const dispatch = useDispatch();
  // Select Modal State
  const selectAddVersionModal = createSelector((state) => state.Modal, (state) => state.addVersionModal);
  const addVersionModal = useSelector(selectAddVersionModal);

  // useEffect(() => {
  //   dispatch(resetVersionDetails());
  // }, [addVersionModal]);

  const selectUploadedFiles = createSelector((state) => state.Upload, (state) => state.uploadedFiles);
  const uploadedFiles = useSelector(selectUploadedFiles);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isReset, setIsReset] = useState(false);

  function handleSubmit() {
    setIsSubmit(true);
  }
  function handleClose() {
    dispatch(toggleAddVersionModal());
    setIsReset(true);
    setTimeout(() => {
      dispatch(resetVersionDetails());
    }, 300);
  }
  async function submitFunc(values) {
    dispatch(setCampaignLoader(true));
    await dispatch(createVersion(values));
    dispatch(toggleAddVersionModal());
    setIsSubmit(false);
    dispatch(setCampaignLoader(false));
  }
  return (
    <Modal isOpen={addVersionModal} toggle={handleClose} centered size="xl">
      <ModalHeader className='p-3' toggle={handleClose}>
        Add New Version
      </ModalHeader>
      <ModalBody className='px-3'>
        <Row>
          <Col lg={8}>
            <UploadCampaign limits={dropFileType} />
          </Col>
          <Col lg={4}>
            <VersionDetails isReset={isReset} isSubmit={isSubmit} submitFunc={async (values) => submitFunc(values)} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DropFileTable />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' type='button' onClick={handleClose}>Close</button>
        <button className='btn btn-success' type='button' onClick={handleSubmit}>Save</button>
      </ModalFooter>
    </Modal>
  )
}

export default AddNewVersion
